<template>
    <spin-while-loading v-if="isFiltersLoading" :dpsin="isFiltersLoading"></spin-while-loading>
    <div v-else class="w3-container zero flow-card tabs-container">
        <div class="w3-row cursor-pointer w3-center flow-margin-top flow-padding-top flow-padding-bottom tabs-container-head">
                <div class="w3-show-inline-block w3-margin-right"
                     @click="currentTabIndex = 0"
                     v-bind:class="currentTabIndex === 0 ? 'active' : 'inactive'">
                    <i class="fa fa-user-md w3-large flow-margin-right"></i>
                    <span class="flow-margin-left">{{$t("physicians")}}</span>
                </div>
                <span class="divider">|</span>
                <div class="w3-show-inline-block w3-margin-right w3-margin-left"
                     @click="currentTabIndex = 1"
                     v-bind:class="currentTabIndex === 1 ? 'active' : 'inactive'">
                    <i class="fa fa-prescription w3-large flow-margin-right"></i>
                    <span class="flow-margin-left">{{$t("appointmentTypes")}}</span>
                </div>
                <span class="divider">|</span>
                <div class="w3-show-inline-block w3-margin-left"
                     @click="currentTabIndex = 2"
                     v-bind:class="currentTabIndex === 2 ? 'active' : 'inactive'">
                    <i class="fa fa-walking w3-large flow-margin-right"></i>
                    <span class="flow-margin-left">{{$t("statuses")}}</span>
                </div>
        </div>

        <div class="w3-row flow-margin-top flow-padding-top" id="patient-filters-content">
            <div class="zero-left flow-btn-checkbox-group flow-padding-top flow-form-inline-input w-100pc">
                <div v-if="currentTabIndex === 0"
                     class="w3-container w3-btn w3-left cursor-pointer w3-ripple flow-btn-checkbox w3-animate-opacity filter-width"
                     v-for="filter in physicianFilters"
                     v-bind:class="filter.isSet ? 'active' : 'inactive'"
                     @click="set(filter)">
                    <div class="w3-col flow-btn-checkbox-icon">
                        <i class="fa"></i>
                    </div>
                    <div class="w3-col flow-btn-checkbox-label">
                        <span>{{ filter.name }}</span>
                    </div>
                </div>

                <div v-if="currentTabIndex === 1"
                     class="w3-container w3-btn w3-left cursor-pointer w3-ripple flow-btn-checkbox w3-animate-opacity filter-width"
                     v-for="filter in consultationGroupFilters"
                     v-bind:class="filter.isSet ? 'active' : 'inactive'"
                     @click="set(filter)">
                    <div class="w3-col flow-btn-checkbox-icon">
                        <i class="fa"></i>
                    </div>
                    <div class="w3-col flow-btn-checkbox-label">
                            <span class="flow-blue-color zero-right font-weight-bold">{{ filter.shortName }} </span>
                            <span class="zero-left">{{ filter.displayName }}</span>
                    </div>
                </div>

                <div v-if="currentTabIndex === 2"
                     class="w3-container w3-btn w3-left cursor-pointer w3-ripple flow-btn-checkbox w3-animate-opacity w-30pc"
                     v-for="filter in statusFilters"
                     v-bind:class="filter.isSet ? 'active' : 'inactive'"
                     @click="set(filter)">

                    <div class="w3-col flow-btn-checkbox-icon">
                        <i class="fa"></i>
                    </div>

                    <div class="w3-col flow-btn-checkbox-label">
                            <span>
                                <patient-status class="w3-show-inline-block" :status="filter.id"></patient-status>
                            </span>
                                <span>
                                {{ $t(filter.id) }}
                            </span>
                    </div>
                </div>
            </div>
            <div class="w3-center w3-padding" id="patient-filters-actions">
                <div>
                    <button class="flow-btn w3-btn  w3-round w3-border w3-ripple w3-round-medium w3-margin w3-padding-small w3-large"
                            v-bind:class="isAllDisabled ? 'w3-disabled' : ''"
                            @click="setAllWithVal(true)">
                        <i class="fa">
                            <span><b class="flow-blue-color">{{ $t("all") }}</b></span>
                        </i>
                    </button>

                    <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-margin w3-padding-small w3-large"
                            v-bind:class="isNoneDisabled ? 'w3-disabled' : ''"
                            @click="setAllWithVal(false)">
                        <i class="fa">
                            <span><b class="flow-blue-color">{{ $t("none") }}</b></span>
                        </i>
                    </button>
                    <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-margin w3-padding-small w3-large"
                            @click="applyFilter">
                        <i class="fa fa-search flow-green-active-color">
                            <span class="flow-margin-left"><b class="flow-margin-left flow-blue-color">{{ $t("search") }}</b></span>
                        </i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { EventBus } from "../../main";
    import PatientStatus from "../common/PatientStatus";
    import SpinWhileLoading from "../common/Loading";

    const frc = Vue.prototype.$frc;

    export default {
        name: "Filters",
        components: {SpinWhileLoading, PatientStatus},
        props: ['onSave'],
        data() {
          return {
              isFiltersLoading: true,
              currentTabIndex: 0,
              physicianFilters: [],
              consultationGroupFilters: [],
              statusFilters: [],
              phyIds: [],
              groupIds: [],
              statusIds: [],
              isAllDisabled: false,
              isNoneDisabled: false
          }
        },
        mounted() {
            EventBus.$on("wardUpdated", this.getFilters);
            this.getFilters();
        },
        beforeDestroy() {
            EventBus.$off("wardUpdated", this.getFilters);
        },
        methods: {
            getFilters() {
                const app = this;
                app.isFiltersLoading = true;
                frc.getPatientFiltersForWard(Vue.prototype.$currentWard.id)
                    .then(function (res) {
                        const data = res.data;
                        app.physicianFilters = data.physicianFilters;
                        app.consultationGroupFilters = data.consultationGroupFilters;
                        app.statusFilters = data.statusFilters;
                        Vue.sortByKey(app.physicianFilters, 'name');
                        Vue.sortByKey(app.consultationGroupFilters, 'displayName');

                        app.updateFilterIds();
                        app.isFiltersLoading = false;
                    })
                    .catch(function (ex) {
                        Vue.notifyError({title: "Something went wrong", message: ex});
                    });
            },
            updateFilterIds() {
                this.phyIds = this.updateFilter(this.physicianFilters);
                this.groupIds = this.updateFilter(this.consultationGroupFilters);
                this.statusIds = this.updateFilter(this.statusFilters);

                this.onSave({phyIds: this.phyIds, groupIds: this.groupIds, statusIds: this.statusIds});
                this.saveFilters();
            },
            saveFilters() {
                frc.savePatientFiltersForWard(Vue.prototype.$currentWard.id, this.phyIds, this.groupIds, this.statusIds);
            },
            updateFilter(filter) {
                var filterIds = [];
                for (var i in filter) {
                    if (filter[i].isSet === true) {
                        filterIds.push(filter[i].id);
                    }
                }

                return filterIds;
            },
            applyFilter() {
                this.updateFilterIds();
            },
            set(filter) {
                filter.isSet = !filter.isSet;
            },
            setAllWithVal(value) {
                var filter;
                if (this.currentTabIndex === 0) {
                    filter = this.physicianFilters;
                } else if (this.currentTabIndex === 1) {
                    filter = this.consultationGroupFilters;
                } else if (this.currentTabIndex === 2) {
                    filter = this.statusFilters;
                }

                for (var i in filter) {
                    filter[i].isSet = value;
                }
            }

        }
    }
</script>

<style scoped>
</style>